import React from 'react';
import {Alert} from 'antd';
import {useTranslation} from '../../../../hooks/useTranslation';

interface EventApprovalProps {
  eventId?: string;
  activePanel: string;
}

const EventApproval: React.FC<EventApprovalProps> = () => {
  const {t} = useTranslation();

  return (
    <div style={{padding: 24}}>
      <Alert
        type="info"
        showIcon
        message={t('events.approval.engineTitle')}
        description={t('events.approval.engineDescription')}
      />
    </div>
  );
};

export default EventApproval;
